import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LlttfInvitationService } from 'src/app/services/llttf-invitation.service';

@Component({
    selector: 'app-access-llttf-cohort',
    templateUrl: './access-llttf-cohort.component.html',
    styleUrls: ['./access-llttf-cohort.component.scss'],
    standalone: false
})
export class AccessLlttfCohortComponent {

  invitationGuid:string=''
  constructor(private _llttfservice:LlttfInvitationService,private router:Router,private route:ActivatedRoute)
  {}
  
  ngOnInit(): void 
  {
    this.route.params.subscribe(params=>{
      this.invitationGuid=params['guid']  
      this._llttfservice.accessCohortLink(this.invitationGuid).subscribe({
        next:(res)=>
          {
            this.router.navigateByUrl(res.redirectTo);
          }
      })
    })
    
  }
}
